module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-user-card-02-3a2aceda66494387076801535fcb1ebb.svg";